'use client';

import { datadogLogs, type Logger } from '@datadog/browser-logs';
import { DataDogBrowserLogsTransport } from '@loglayer/transport-datadog-browser-logs';
import { ConsoleTransport, LogLayer } from 'loglayer';
import { serializeError } from 'serialize-error';

import { getLegacyEnvVariable } from '@/app/components/LegacyEnvVariables/util';

import { LOGGER_NAME } from './consts';
import type { LogPayload } from './types';

let logger: Logger | undefined;

const getLogger = (): Logger => {
  if (!logger) {
    logger = datadogLogs.createLogger(LOGGER_NAME);
  }
  return logger;
};

const logToDatadogClient = ({
  data = {},
  error,
  level = 'info',
  message,
  module,
}: LogPayload) => {
  const isDevelopment =
    getLegacyEnvVariable('NEXT_PUBLIC_OURA_ENV') === 'development';

  let log: LogLayer;

  // Don't send logs to Datadog for local development
  if (!isDevelopment) {
    log = new LogLayer({
      errorSerializer: serializeError,
      transport: new DataDogBrowserLogsTransport({
        logger: getLogger(),
      }),
    });
  } else {
    log = new LogLayer({
      errorSerializer: serializeError,
      transport: new ConsoleTransport({
        level,
        logger: console,
      }),
    });
  }

  return log
    .withError(error)
    .withMetadata({ ...data, module })
    [level](message);
};

export default logToDatadogClient;
